import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}')({
  beforeLoad: () => getTitleContextSlice('Rule Detail'),
});
